var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-label",class:_vm.classNames},[_c('div',{staticClass:"content"},[(_vm.glyph)?_c('a-glyph',{attrs:{"name":_vm.glyph,"size":_vm.glyphSize}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }